import Vue from 'vue';
import i18n from '@/providers/i18n';
import {formatNumber, dateformat} from './fields'
import _ from 'lodash'

//translation
Vue.filter('trans', (s, r = {}) => i18n.i18next.t(s, r));

//strip_tags
Vue.filter('strip_tags', strip_tags);

Vue.filter('text', _.unescape);
Vue.filter('unescape', _.unescape);

//shorten
Vue.filter('shorten', (s, n = 0) => {
  if (!n || s.length <= n) {
    return s;
  } else {
    return s.substring(0, n) + String.fromCharCode(0x2026);
  }
});
Vue.directive('shorten', {
  bind (el, binding) {
    var n = binding.value || 0;
    var s = el.innerHTML;
    if (s.length > n) {
      el.setAttribute('title', s);
      el.innerHTML = s.substring(0, n) + String.fromCharCode(0x2026);
    }
  }
})

//number with fixed decimals
Vue.filter('number', (s, n = 0) => {
  s = Number(s);
  if (isNaN(s)) {
    return '';
  }
  return String(formatNumber(s, n));
});

//price
Vue.filter('price', (n, currency = false) => {
  n = Number(n);
  if (isNaN(n)) {
    return '';
  }
  return String(formatNumber(n, 2)) + (currency ? unescape('%u00A0') + currency : '');
});
//dates
Vue.filter('date', (s) => {
  return dateformat(s, 'DD.MM.YYYY');
});
Vue.filter('datetime', (s) => {
  return dateformat(s, 'DD.MM.YYYY HH:mm:ss');
});

//ordinal numbers
const suffixes = ["th", "st", "nd", "rd"];

Vue.filter('ordinal', (s) => {
  var n = Number(s);
  if (isNaN(n)) {
    return s;
  }
  if (i18n.i18next.language === 'en') {
    var v = Math.abs(n) % 100;
    var suffix = suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0];
    return String(s) + suffix;
  } else {
    return String(s) + '.';
  }
});


// WEBPACK FOOTER //
// ./src/providers/filters.js